// Dependent on custom select

// Event calendar
function refreshEventCalendar(elem, selected, select) {

    var month_year = $('input.selected');

    if (selected.getAttribute("month") !== null) {
        var month = selected.getAttribute("month");
        month_year.attr('month', month);
    }
    if (selected.getAttribute("year") !== null) {
        var year = selected.getAttribute("year");
        month_year.attr('year', year);
    }

    if (select.getAttribute('class') === 'month') {
        var month = select.options[select.selectedIndex].value;
        month_year.attr('month', month);
        year = month_year.attr('year');
    }

    if (select.getAttribute('class') === 'year') {
        var year = select.options[select.selectedIndex].value;
        month_year.attr('year', year);
        month = $('input.selected').attr('month');
    }

    $(elem).closest('.em-calendar-wrapper').prepend('<div class="loading" id="em-loading"></div>');

    var url = em_ajaxify('/?long_events=1&ajaxCalendar=1&mo=' + month + '&yr=' + year + '&em_ajax=1');

    $(elem).closest('.em-calendar-wrapper').load(url, function () {
        $(elem).trigger('em_calendar_load');
        initCustomSelects();
    });
}

function createPostForBooking(elem, selected, select){
    var select_name = select.getAttribute('name');
    if(select_name === 'tickets'){
        var value = select.options[select.selectedIndex].value;
        var text = select.options[select.selectedIndex].text;
        console.log(value);
        console.log(text);
        //remove input
        var ticket_input = document.getElementById("em-ticket-spaces");
        if(ticket_input){
            ticket_input.remove();
        }

        if(value && text){
            //create new input
            document.getElementById("ticket-input").innerHTML = '<input type="hidden" class="em-ticket-select" id="em-ticket-spaces" name="em_tickets['+ value +'][spaces]" value="1">';
        }
    }
}

// Gets correct select width even if display:none
function hiddenWidth(elem) {

    var tmp = elem.cloneNode(true);
    tmp.style.position = 'absolute';
    tmp.style.top = '-300%';
    document.body.appendChild(tmp);
    var w = tmp.offsetWidth;
    tmp.parentNode.removeChild(tmp);
    return w;
}

// Init
function initCustomSelects() {

    var x, i, j, selElmnt, a, b, c;
    /*look for any elements with the class "custom-select":*/
    x = document.getElementsByClassName("custom-select");

    for (i = 0; i < x.length; i++) {
        selElmnt = x[i].getElementsByTagName("select")[0];
        /*for each element, create a new DIV that will act as the selected item:*/
        a = document.createElement("DIV");
        a.setAttribute("class", "custom-select__select-selected");
        a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
        a.setAttribute(selElmnt.getAttribute("class"), selElmnt.options[selElmnt.selectedIndex].value);

        x[i].appendChild(a);
        /*for each element, create a new DIV that will contain the option list:*/
        b = document.createElement("DIV");
        b.setAttribute("class", "custom-select__select-items custom-select__select-hide");

        for (j = 0; j < selElmnt.length; j++) {

            /*for each option in the original select element,
             create a new DIV that will act as an option item:*/
            c = document.createElement("DIV");
            c.innerHTML = selElmnt.options[j].innerHTML;

            c.addEventListener("click", function (e) {
                /*when an item is clicked, update the original select box,
                 and the selected item:*/
                var i, s, h;
                s = this.parentNode.parentNode.getElementsByTagName("select")[0];
                h = this.parentNode.previousSibling;

                for (i = 0; i < s.length; i++) {
                    if (s.options[i].innerHTML == this.innerHTML) {
                        s.selectedIndex = i;
                        h.innerHTML = this.innerHTML;
                        break;
                    }
                }

                h.click();

                // If custom select is for event calendar, refresh it
                if(document.getElementsByClassName('event-callendar').length) {
                    refreshEventCalendar(this, a, s);
                }

                //if custom select if for booking tickets
                if(document.getElementsByClassName('tickets-select').length) {
                    createPostForBooking(this, a, s);
                }
            });

            b.appendChild(c);
        }
        x[i].appendChild(b);
        a.addEventListener("click", function (e) {
            /*when the select box is clicked, close any other select boxes,
             and open/close the current select box:*/
            e.stopPropagation();
            closeAllSelect(this);
            this.nextSibling.classList.toggle("custom-select__select-hide");
            this.classList.toggle("custom-select__select-arrow-active");
        });

        // Set selected item div width to widest option div
        x[i].style.width = hiddenWidth(b) + 'px';
    }

    /*if the user clicks anywhere outside the select box,
    then close all select boxes:*/
    document.addEventListener("click", closeAllSelect);
}

function closeAllSelect(elmnt) {
    /*a function that will close all select boxes in the document,
     except the current select box:*/
    var x, y, i, arrNo = [];
    x = document.getElementsByClassName("custom-select__select-items");
    y = document.getElementsByClassName("custom-select__select-selected");
    for (i = 0; i < y.length; i++) {
        if (elmnt == y[i]) {
            arrNo.push(i)
        } else {
            y[i].classList.remove("custom-select__select-arrow-active");
        }
    }
    for (i = 0; i < x.length; i++) {
        if (arrNo.indexOf(i)) {
            x[i].classList.add("custom-select__select-hide");
        }
    }
}

$(function(){
    initCustomSelects();
});